import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import ReviewsSection from "./ReviewsSection";

export default function ReviewsModal({ open, onOpenChange, deal, onSummaryChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[560px] bg-white rounded-none border-2 border-black p-0" data-testid="reviews-modal">
        <DialogHeader className="border-b border-black/10 p-6 pb-4">
          <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-black/50 mb-1">Community reviews</div>
          <DialogTitle className="font-serif text-2xl font-black tracking-tight leading-tight">
            {deal?.title}
          </DialogTitle>
        </DialogHeader>
        <ReviewsSection
          deal={deal}
          active={open}
          onSummaryChange={onSummaryChange}
          variant="modal"
        />
      </DialogContent>
    </Dialog>
  );
}
